export const ADD_PROXIES = 'ADD_PROXIES';
export const ADD_PROXIES_SUCCESS = 'ADD_PROXIES_SUCCESS';
export const ADD_PROXIES_FAILURE = 'ADD_PROXIES_FAILURE';

export const UPDATE_PROXY = 'UPDATE_PROXY';
export const UPDATE_PROXY_SUCCESS = 'UPDATE_PROXY_SUCCESS';
export const UPDATE_PROXY_FAILURE = 'UPDATE_PROXY_FAILURE';

export const GET_PROXY_USER_LIST = 'GET_PROXY_USER_LIST';
export const GET_PROXY_USER_LIST_SUCCESS = 'GET_PROXY_USER_LIST_SUCCESS';
export const GET_PROXY_USER_LIST_FAILURE = 'GET_PROXY_USER_LIST_FAILURE';

export const GET_PROXY_LIST = 'GET_PROXY_LIST';
export const GET_PROXY_LIST_SUCCESS = 'GET_PROXY_LIST_SUCCESS';
export const GET_PROXY_LIST_FAILURE = 'GET_PROXY_LIST_FAILURE';

export const REVOKE_PROXIES = 'REVOKE_PROXIES';
export const REVOKE_PROXIES_SUCCESS = 'REVOKE_PROXIES_SUCCESS';
export const REVOKE_PROXIES_FAILURE = 'REVOKE_PROXIES_FAILURE';

export const INITIATE_PROXY = 'INITIATE_PROXY';
export const INITIATE_PROXY_SUCCESS = 'INITIATE_PROXY_SUCCESS';
export const INITIATE_PROXY_FAILURE = 'INITIATE_PROXY_FAILURE';

export const TERMINATE_PROXY = 'TERMINATE_PROXY';
export const TERMINATE_PROXY_SUCCESS = 'TERMINATE_PROXY_SUCCESS';
export const TERMINATE_PROXY_FAILURE = 'TERMINATE_PROXY_FAILURE';

export const SET_UPDATE_POPUP = 'SET_UPDATE_POPUP';
